import axios from 'axios';
import apiConfig from '../../api.config';

export default function getHotelTexts(hotelId, types) {
    // expect type as an array
  const {
    host,
    URIs: { getHotelTexts },
  } = apiConfig;

  const uri = `${host}${getHotelTexts.replace(':hotelId', hotelId)}?types=${types}`;

  return axios.get(uri, {}).then(res => {
    return res.data;
  });
}
